import React, { createContext, useMemo } from "react";
import PropTypes from "prop-types";

export const UserContext = createContext();

export const UserProvider = ({ children, loggedInUser, setLoggedInUser }) => {
  const value = useMemo(
    () => ({ loggedInUser, setLoggedInUser }),
    [loggedInUser, setLoggedInUser]
  );
  return <UserContext.Provider value={value}>{children}</UserContext.Provider>;
};

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
  loggedInUser: PropTypes.object,
  setLoggedInUser: PropTypes.func.isRequired,
};
